import icon_gamepad from '../assets/icon_gamepad.png';

function DelayedHeader() {
  return (
    <div className="DelayedHeader">
        <img src={icon_gamepad} alt="icon_gamepad" />
        <h1>VerbalVortex</h1>
    </div>
  );
}

export default DelayedHeader;
